export const DELETE_ENTITY_MAX_COUNT = 10;
export const DELETE_ENTITY_ADMIN_MAX_COUNT = 100;
